import React, { memo, useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/react-hooks';

import { MapMarkerAltSolidIcon } from '../../shared/icons/icons';

import { GET_SIGNED_STATIC_MAP_URL } from './graphql/static-map-queries';

import { GeoPoint } from '../../shared/types/graphql-types';

import './static-map.scss';

interface Markers extends GeoPoint {
  isPitpass?: boolean;
}

interface StaticMapProps {
  apiKey?: string;
  centerPos: GeoPoint;
  height: number;
  isMyStore: boolean;
  mapAlt?: string;
  markers?: Array<Markers>;
  showCenterMarker?: boolean;
  width: number;
  zoom?: number;
}

function StaticMap(props: StaticMapProps) {
  const {
    apiKey = process.env.__GOOGLE_API_KEY__,
    isMyStore = false,
    showCenterMarker = true,
    centerPos = null,
    zoom,
    width = 700,
    height = 350,
    markers: markersProp
  } = props;

  const client = useApolloClient();
  const [signedMapUrl, setSignedMapUrl] = useState();

  function queryMapImage() {
    let markers = '';
    let query = `center=${centerPos?.latitude},${centerPos?.longitude}&size=${width}x${height}`;

    if (zoom) {
      query += `&zoom=${zoom}`;
    }

    if (markersProp) {
      markers = markersProp.reduce(
        (acc, m, idx) =>
          `${acc}&markers=icon:https://discounttire.scene7.com/is/image/discounttire/${
            m?.isPitpass ? 'PP' : 'Reg'
          }_StaticMapPin_${(idx + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })}?fmt=png-alpha%7C${m?.latitude},${m?.longitude}`,
        ''
      );
    }

    return `https://maps.googleapis.com/maps/api/staticmap?${query}${markers}&key=${apiKey}`;
  }

  const unsignedMapUrl = centerPos && height && width ? queryMapImage() : null;

  useEffect(() => {
    (async function () {
      if (unsignedMapUrl) {
        const { data } = await client.query({
          query: GET_SIGNED_STATIC_MAP_URL,
          variables: {
            url: unsignedMapUrl
          }
        });

        if (data?.store.signStaticMapUrl) {
          setSignedMapUrl(data.store.signStaticMapUrl);
        }
      }
    })();
  }, [client, unsignedMapUrl]);

  let imgUrl;

  if (signedMapUrl) {
    imgUrl = signedMapUrl;
  }

  return (
    <div
      style={imgUrl ? { backgroundImage: `url(${imgUrl})` } : undefined}
      styleName="container"
    >
      {showCenterMarker && (
        <MapMarkerAltSolidIcon
          styleName={isMyStore ? 'my-store-marker' : 'marker'}
        />
      )}
    </div>
  );
}

export default memo(StaticMap);
